var cov_1zu0fjtspn = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/utils/validate/rangeLength.ts",
      hash = "19eadab9b32225347264304f822ce904e596cc3e",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/utils/validate/rangeLength.ts",
    statementMap: {
      "0": {
        start: {
          line: 3,
          column: 75
        },
        end: {
          line: 23,
          column: 1
        }
      },
      "1": {
        start: {
          line: 4,
          column: 32
        },
        end: {
          line: 4,
          column: 39
        }
      },
      "2": {
        start: {
          line: 5,
          column: 16
        },
        end: {
          line: 5,
          column: 34
        }
      },
      "3": {
        start: {
          line: 7,
          column: 2
        },
        end: {
          line: 11,
          column: 3
        }
      },
      "4": {
        start: {
          line: 8,
          column: 4
        },
        end: {
          line: 9,
          column: 23
        }
      },
      "5": {
        start: {
          line: 8,
          column: 13
        },
        end: {
          line: 8,
          column: 28
        }
      },
      "6": {
        start: {
          line: 9,
          column: 9
        },
        end: {
          line: 9,
          column: 23
        }
      },
      "7": {
        start: {
          line: 10,
          column: 4
        },
        end: {
          line: 10,
          column: 10
        }
      },
      "8": {
        start: {
          line: 13,
          column: 14
        },
        end: {
          line: 13,
          column: 80
        }
      },
      "9": {
        start: {
          line: 15,
          column: 2
        },
        end: {
          line: 22,
          column: 3
        }
      },
      "10": {
        start: {
          line: 19,
          column: 4
        },
        end: {
          line: 19,
          column: 19
        }
      },
      "11": {
        start: {
          line: 21,
          column: 4
        },
        end: {
          line: 21,
          column: 18
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 3,
            column: 15
          },
          end: {
            line: 3,
            column: 16
          }
        },
        loc: {
          start: {
            line: 3,
            column: 75
          },
          end: {
            line: 23,
            column: 1
          }
        },
        line: 3
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 3,
            column: 75
          },
          end: {
            line: 3,
            column: 76
          }
        },
        loc: {
          start: {
            line: 3,
            column: 150
          },
          end: {
            line: 23,
            column: 1
          }
        },
        line: 3
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 7,
            column: 2
          },
          end: {
            line: 11,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 7,
            column: 2
          },
          end: {
            line: 11,
            column: 3
          }
        }, {
          start: {
            line: 7,
            column: 2
          },
          end: {
            line: 11,
            column: 3
          }
        }],
        line: 7
      },
      "1": {
        loc: {
          start: {
            line: 8,
            column: 4
          },
          end: {
            line: 9,
            column: 23
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 8,
            column: 4
          },
          end: {
            line: 9,
            column: 23
          }
        }, {
          start: {
            line: 8,
            column: 4
          },
          end: {
            line: 9,
            column: 23
          }
        }],
        line: 8
      },
      "2": {
        loc: {
          start: {
            line: 13,
            column: 14
          },
          end: {
            line: 13,
            column: 80
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 13,
            column: 42
          },
          end: {
            line: 13,
            column: 65
          }
        }, {
          start: {
            line: 13,
            column: 68
          },
          end: {
            line: 13,
            column: 80
          }
        }],
        line: 13
      },
      "3": {
        loc: {
          start: {
            line: 15,
            column: 2
          },
          end: {
            line: 22,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 15,
            column: 2
          },
          end: {
            line: 22,
            column: 3
          }
        }, {
          start: {
            line: 15,
            column: 2
          },
          end: {
            line: 22,
            column: 3
          }
        }],
        line: 15
      },
      "4": {
        loc: {
          start: {
            line: 16,
            column: 4
          },
          end: {
            line: 17,
            column: 63
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 16,
            column: 5
          },
          end: {
            line: 16,
            column: 22
          }
        }, {
          start: {
            line: 16,
            column: 26
          },
          end: {
            line: 16,
            column: 49
          }
        }, {
          start: {
            line: 16,
            column: 53
          },
          end: {
            line: 16,
            column: 62
          }
        }, {
          start: {
            line: 17,
            column: 5
          },
          end: {
            line: 17,
            column: 22
          }
        }, {
          start: {
            line: 17,
            column: 26
          },
          end: {
            line: 17,
            column: 49
          }
        }, {
          start: {
            line: 17,
            column: 53
          },
          end: {
            line: 17,
            column: 62
          }
        }],
        line: 16
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0
    },
    f: {
      "0": 0,
      "1": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0, 0, 0, 0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import { isEmpty } from '../is';
export default (function (options) {
  cov_1zu0fjtspn.f[0]++;
  cov_1zu0fjtspn.s[0]++;
  return function (value, _formdata, callback) {
    cov_1zu0fjtspn.f[1]++;

    var _ref = (cov_1zu0fjtspn.s[1]++, options),
        min = _ref.min,
        max = _ref.max,
        message = _ref.message;

    var error = (cov_1zu0fjtspn.s[2]++, new Error(message));
    cov_1zu0fjtspn.s[3]++;

    if (isEmpty(value)) {
      cov_1zu0fjtspn.b[0][0]++;
      cov_1zu0fjtspn.s[4]++;

      if (min) {
        cov_1zu0fjtspn.b[1][0]++;
        cov_1zu0fjtspn.s[5]++;
        callback(error);
      } else {
        cov_1zu0fjtspn.b[1][1]++;
        cov_1zu0fjtspn.s[6]++;
        callback(true);
      }

      cov_1zu0fjtspn.s[7]++;
      return;
    } else {
      cov_1zu0fjtspn.b[0][1]++;
    }

    var len = (cov_1zu0fjtspn.s[8]++, typeof value === 'number' ? (cov_1zu0fjtspn.b[2][0]++, value.toString().length) : (cov_1zu0fjtspn.b[2][1]++, value.length));
    cov_1zu0fjtspn.s[9]++;

    if ((cov_1zu0fjtspn.b[4][0]++, len !== undefined) && (cov_1zu0fjtspn.b[4][1]++, typeof min === 'number') && (cov_1zu0fjtspn.b[4][2]++, len < min) || (cov_1zu0fjtspn.b[4][3]++, len !== undefined) && (cov_1zu0fjtspn.b[4][4]++, typeof max === 'number') && (cov_1zu0fjtspn.b[4][5]++, len > max)) {
      cov_1zu0fjtspn.b[3][0]++;
      cov_1zu0fjtspn.s[10]++;
      callback(error);
    } else {
      cov_1zu0fjtspn.b[3][1]++;
      cov_1zu0fjtspn.s[11]++;
      callback(true);
    }
  };
});